<template>
    <b-form-group style="max-width: 500px">
        <template slot="label">
            <div class="d-flex">
                <div class="font-weight-bold text-muted mr-3">
                    {{ $t('nBox.resultType') }}
                </div>
                <b-badge variant="primary">
                    {{ $t('targets.targets') }}
                </b-badge>
            </div>
        </template>
        <b-form-select
            size="sm"
            :state="state"
            :value="model"
            :options="options"
            @input="model = $event"
        />
    </b-form-group>
</template>
<script>
import i18n from '@/i18n'
export default {
    props: {
        selected: {
            type: String,
            default: null,
        },
        state: {
            type: Boolean,
            default: null,
        },
    },
    data() {
        return {
            model: this.selected,
        }
    },
    computed: {
        options: () => [
            {
                text: i18n.t('nBox.selectAnOption'),
                value: null,
            },
            {
                text: i18n.t('nBox.accomplished'),
                value: 'accomplished',
            },
            {
                text: i18n.t('profile.targetsTable.selfEvaluate'),
                value: 'owner_evaluation',
            },
            {
                text: i18n.t('nBox.managerEvaluation'),
                value: 'manager_evaluation',
            },
            {
                text: i18n.t('nBox.commiteeEvaluation'),
                value: 'committee_evaluation',
            },
        ],
    },
    watch: {
        model() {
            this.$emit('change', this.model)
        },
    },
}
</script>
